// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2tYAx","author":"Table_author__28m3B","authorImage":"Table_authorImage__MOZKF","unreadRow":"Table_unreadRow__jKHoL"};